export default Object.freeze({
  PendingReview: 1,
  Approved: 2,
  Rejected: 3,
});
